import { refreshToken } from './refreshToken';
import { logger } from '@myorg/type-lib';
export let unauthorizedHandler = null;
export function setUnauthorizedHandler(handler) {
    logger.log('[Auth Interceptor] 🛑 setUnauthorizedHandler 被呼叫了！綁定的 handler 存在:', !!handler);
    unauthorizedHandler = handler;
}
export function setupAuthInterceptor(api, baseURL) {
    let isRefreshing = false;
    let failedQueue = [];
    const processQueue = (error) => {
        logger.log(`[Auth Interceptor] 🔄 開始清空佇列。錯誤狀態: ${error ? error.message : '無錯誤(成功)'}, 佇列長度: ${failedQueue.length}`);
        failedQueue.forEach(prom => {
            if (error) {
                prom.reject(error);
            }
            else {
                prom.resolve();
            }
        });
        failedQueue = [];
    };
    api.defaults.withCredentials = true;
    api.interceptors.response.use(res => res, async (error) => {
        const original = error.config;
        if (!original) {
            logger.error('[Auth Interceptor] ❌ 嚴重錯誤：拿不到 error.config');
            throw error;
        }
        logger.warn(`[Auth Interceptor] ⚠️ 捕獲到請求失敗! URL: ${original.url}, Status: ${error.response?.status}`);
        // 🛡️ 核心保險：如果失敗的請求本身就是刷新 Token，直接拋出，拒絕進入排隊佇列！
        if (original.url?.includes('/api/client/refresh')) {
            logger.log('[Auth Interceptor] 🛑 偵測到刷新 Token 請求失敗，直接拋出，避免無窮防禦死鎖。');
            throw error;
        }
        // 1. 如果標記了跳過全域處理，直接丟回給組件
        if (original._skipGlobalError) {
            logger.log(`[Auth Interceptor] ⏭️ 偵測到 _skipGlobalError = true, 跳過攔截器直接拋出。 URL: ${original.url}`);
            throw error;
        }
        // 2. 如果不是 401 或已經重試過，直接拋出錯誤
        if (error.response?.status !== 401 || original._retry) {
            logger.log(`[Auth Interceptor] ↩️ 不滿足刷新條件 (不是401 或 已重試過 _retry=${original._retry})，直接拋出錯誤。`);
            throw error;
        }
        original._retry = true;
        // 3. 如果正在刷新中，將請求加入佇列
        if (isRefreshing) {
            logger.log(`[Auth Interceptor] ⏳ 目前正有其他請求在刷新 Token，將此請求推進排隊佇列: ${original.url}`);
            return new Promise((resolve, reject) => {
                failedQueue.push({
                    resolve: async () => {
                        try {
                            logger.log(`[Auth Interceptor] 🚀 佇列釋放：重新發送排隊中的請求: ${original.url}`);
                            const response = await api(original);
                            resolve(response);
                        }
                        catch (err) {
                            reject(err);
                        }
                    },
                    reject: (err) => reject(err)
                });
            });
        }
        logger.log(`[Auth Interceptor] 🔑 這是第一個觸發 401 的請求。鎖定 status (isRefreshing = true)，開始執行靜默刷新...`);
        isRefreshing = true;
        try {
            logger.log(`[Auth Interceptor] 📡 發送 Refresh Token 請求至後端... URL: ${baseURL}`);
            await refreshToken(baseURL);
            logger.log(`[Auth Interceptor] ✅ Token 刷新成功！`);
            processQueue(null);
            logger.log(`[Auth Interceptor] 🔄 重新發送當初引發 401 的原始請求: ${original.url}`);
            return api(original);
        }
        catch (err) {
            logger.error(`[Auth Interceptor] 💥 Token 刷新失敗 (可能 Refresh Token 也過期了)！錯誤訊息:`, err);
            // 4. 刷新失敗：清空並拒絕所有排隊中的請求
            processQueue(err);
            logger.log(`[Auth Interceptor] 🚨 準備觸發登出回呼。目前全域 unauthorizedHandler 的狀態是:`, unauthorizedHandler);
            if (unauthorizedHandler) {
                logger.log('[Auth Interceptor] 📣 執行真正的 unauthorizedHandler()...');
                unauthorizedHandler();
            }
            else {
                logger.error('[Auth Interceptor] ❌ 致命錯誤：unauthorizedHandler 是 null！main.ts 的綁定沒有生效，或兩邊導入的模組不同步！');
            }
            throw err;
        }
        finally {
            isRefreshing = false;
            logger.log(`[Auth Interceptor] 🔓 解除鎖定 (isRefreshing = false)`);
        }
    });
}
